<template>
  <v-container>
    <v-row class="ma-0">
      <v-col cols="12" class="d-flex">
        <div>
          <h1>Detalhes do lote</h1>
          <p class="mb-0">
            Visualize os dados do Lote e edite as Guias
          </p>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          height="30px"
          small
          color="primary"
          class="px-2 ml-3"
          depressed
          @click="$router.push('/faturamento/cronogramas/dadosdocronograma/'+loteDataInfo.cronograma_id)"
        >Fechar</v-btn>
        <v-btn
          outlined
          height="30px"
          small
          color="primary"
          class="px-2 ml-3"
          depressed
          @click="desalocaLote(payload)"
        >Liberar edição</v-btn>
         <v-btn
          outlined
          height="30px"
          small
          color="primary"
          class="px-2 ml-3"
          depressed
          @click="showOpen('historico')"
        >Histórico de edições</v-btn>
         <v-btn
          outlined
          height="30px"
          small
          color="primary"
          class="px-2 ml-3"
          depressed
          @click="showOpen('desfazer')"
        >Desfazer de edições</v-btn>
        <v-btn
          height="30px"
          small
          color="primary"
          class="px-2 ml-3"
          depressed
          @click="showOpen('concluir')"
        >Concluir edição</v-btn>
      </v-col>
      <v-col cols="12">
          <DetalhesLoteInfo
            :info="loteDataInfo"
          />
          <v-divider></v-divider>
          <GuiasFilter
            :userData="userData"
            :showOpen="(str) => showOpen(str)"
            :filterList="(filter) => filterList(filter)"
            :updateShow="updateShow"
            :deleteGuia="() => deleteGuia()"
          />
          <GuiasList
            v-show="!updateShow"
            :formatDate="(date) => formatDate(date)"
            :parseDate="(date) => parseDate(date)"
            :selectGuias="(item) => selectGuias(item)"
            :updateGuia="(id) => updateGuia(id)"
            :getList="() => getGuias()"
            :list="guiasFilter"
          />
          <EdicaoEmMassa
            v-show="updateShow"
            :camposList="loteDataInfo.campos_edicao_xml"
            :dominiosList="loteDataInfo.dominio_tiss"
            :updateGuias="(formData)=>updateGuias(formData)"
            :updateGuiasResult="updateGuiasResult"
            :showOpen="(str) => showOpen(str)"
            :showClose="() => showClose('update_massa')"
            :grupoEconomico="grupoEconomico"
            :tipoGuiaId="loteDataInfo.tipo_guia_id"
          />
      </v-col>
    </v-row>
    <GuiasCriticasDlg
      v-if="itemError != null"
      :dialog="showError"
      :showClose="() => showClose('critica')"
      :critica="itemError"
    />
    <GuiasCriticasDlg
      v-else
      :dialog="showError"
      :showClose="() => showClose('critica')"
      :critica="itemCritica"
    />
    <DlgEditaGuia
      :dialog="updateDlg"
      :openDlg="() => updateDlg = true"
      :getGuia="getGuia"
      :getGuias="() => getGuias(payload)"
      :showClose="() => showClose('update_guia')"
      :showOpen="() => showOpen('critica')"
      :formatDate="(date) => formatDate(date)"
      :parseDate="(date) => parseDate(date)"
      :selectDespesas="(itemE, itemO, type) => deleteDespesa(itemE, itemO, type)"
      :typeGuia="loteDataInfo.descricao"
      :camposList="loteDataInfo.campos_edicao_xml"
      :dominiosList="loteDataInfo.dominio_tiss"
      :versaoMaior="versaoMaior"
    />
    <HistoricoEdicoesDlg
      :dialog="showHistorico"
      :close="() => showHistorico = false"
      :historico="historicoEdicoes"
      />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import DetalhesLoteInfo from './detalhes_lote/DetalhesLoteInfo'
import GuiasFilter from './detalhes_lote/GuiasFilter'
import GuiasList from './detalhes_lote/GuiasList'
import EdicaoEmMassa from './detalhes_lote/EdicaoEmMassa'
import GuiasCriticasDlg from './detalhes_lote/GuiasCriticasDlg'
import DlgEditaGuia from './detalhes_lote/DlgEditaGuia'
import HistoricoEdicoesDlg from './detalhes_lote/HistoricoEdicoesDlg'
export default {
  components: {
    DetalhesLoteInfo,
    GuiasFilter,
    GuiasList,
    EdicaoEmMassa,
    GuiasCriticasDlg,
    DlgEditaGuia,
    HistoricoEdicoesDlg
  },
  data() {
    return {
      loteDataInfo: {},
      router: null,
      showError: false,
      updateShow: false,
      updateDlg: false,
      updateGuiasResult: null,
      errorList: {},
      guiasList: [],
      guiasFilter: [],
      guiasSelectList: [],
      editedGuias: [],
      getGuia: {
        grupo_economico: null,
        id: null
      },
      camposList:[],
      dominiosList:[],
      payload: {},
      itemError: null,
      itemCritica: null,
      errorType: null,
      versaoMaior: false,
      historicoEdicoes:[],
      showHistorico: false
    }
  },
  computed:{
    ...mapState({
      userData: (state) => state.userData.userData,
      grupoEconomico: state => state.permissions.grupoEconomico,
    })
  },
  mounted() {
    let opts = {
      grupo_economico: this.grupoEconomico,
      id: this.$route.params.id
    }
    this.getDetalhesLote(opts)
    this.getGuias(opts)
  },
  watch: {
    $route(val) {
      let opts = {
        grupo_economico: this.grupoEconomico,
        id: val.params.id
      }
      this.getDetalhesLote(opts)
      this.getGuias(opts)
    }
  },
  methods: {
    ...mapActions('faturamento', [
      'getLotesAlocados'
    ]),
    showOpen(type) {
      let paramModal = {
        type: "warning",
        btConfirm: { name: "Concluir", show: true },
        btCancel: { name: "Cancelar", show: true },
      }
      let opts = {
        grupo_economico: this.grupoEconomico,
        lote_id: this.payload.id
      }
      switch (type) {
        case 'concluir':
          paramModal.title = "Deseja concluir a edição deste lote?"
          paramModal.message = 'A edição ficará indisponível e o lote voltará para a fase de validação do XML.'
          paramModal.callback = () => this.edicaoLote('finalizaedicaoguia', opts)
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
          break
        case 'desfazer':
          paramModal.title = "Desfazer edição?"
          paramModal.message = 'O lote voltará ao estado inicial e <br/> perderá todas edições feitas.'
          paramModal.callback = () => this.edicaoLote('desfazedicaolote', opts)
          paramModal.btConfirm.name = 'Desfazer'
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
          break
        case 'historico':
          this.getHistorico(opts)
          break
        case 'update_massa':
          this.updateShow = true
          break
        case 'critica':
          this.getError(this.payload)
          break
      }
    },
    showClose(type) {
      let opts = {
            grupo_economico: this.grupoEconomico,
            id: this.$route.params.id
          }
      switch (type) {
        case 'critica':
          this.showError = false
        break
        case 'update_massa': 
          this.getGuias(opts)
          this.updateShow = false
        break
        case 'update_guia':
          this.updateDlg = false
        break
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split("-")
      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split("/")
      return `${year}-${month}-${day}`
    },
    getDetalhesLote(payload) {
      let obj = {query:[ {acao: 'getdetalheslote', modulo: 'Faturamento', payload}], returnError: true}
      this.$store.dispatch("request/doRequest",obj ,{root: true}).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          let paramModal = {
            type: "error",
            title: "Ocorreu erro",
            message: response.erros[0].descricao,
            callback: () => {
              this.$router.push('/faturamento/cronogramas/dadosdocronograma/'+response.cronograma_id)
            },
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          return false
        }
        if(response.cronograma_id) {
          this.$store.commit("permissions/saveId", {pathName:'dadosdocronograma', id: response.cronograma_id });
        }
         if(response.response){
                let error = response
                let paramModal = {}
                      paramModal.message = error.response &&  error.response.data ? (error.response.data.errors ? Object.values(error.response.data.errors).join('<br>') :
                              (error.response.data.message)) : 'Contate o administrador do sistema'
                      paramModal.title = 'Ocorreu erro'
                      paramModal.type = 'error'
                      paramModal.callback = null
                      paramModal.btConfirm = {
                          name: 'Ok',
                          show: true
                      }
                      paramModal.btCancel = {
                          name: 'Cancelar',
                          show: false
                      }
                      
                      this.$store.commit('confirmMessage/showConfirmMessage', paramModal, {root: true})
                      return error
            }
        this.$store.commit('hideLoader')
        this.loteDataInfo = response
        const [v1, v2, v3] = response.arq_versao.split('.')
        let versao = Number(`${v1}${v2}${v3}`)
        this.versaoMaior = versao >= 30400
      })
      setTimeout(() => {this.getLotesAlocados({grupo_economico: this.grupoEconomico})},20)
    },
    getGuias(opts) {
      this.payload = opts
      let grupo_economico = opts.grupo_economico
      let lote_id = opts.id
      let payload = {grupo_economico, lote_id}
      let obj = {query:[{modulo: 'Faturamento', acao: 'getguias', payload}], returnError: true}
      this.$store.dispatch("request/doRequest",obj).then(resp => {
        this.guiasList = resp.dados? resp.dados : []
        this.filterList(this.guiasList)
        if(resp.response){
                let error = resp
                let paramModal = {}
                      paramModal.message = error.response &&  error.response.data ? (error.response.data.errors ? Object.values(error.response.data.errors).join('<br>') :
                              (error.response.data.message)) : 'Contate o administrador do sistema'
                      paramModal.title = 'Ocorreu erro'
                      paramModal.type = 'error'
                      paramModal.callback = null
                      paramModal.btConfirm = {
                          name: 'Ok',
                          show: true
                      }
                      paramModal.btCancel = {
                          name: 'Cancelar',
                          show: false
                      }
                      
                      this.$store.commit('confirmMessage/showConfirmMessage', paramModal, {root: true})
                      return error
            }
          this.$store.commit('hideLoader')
      })
    },
    getHistorico(payload) {
        // this.historicoEdicoes = [{
        //     "id": '1',
        //     "arquivo_id": '1202020123',
        //     "acao": 'updateguia',
        //     "alteracao": 'Lorem ipsum dolor sit amet',
        //     "user_id_alteracao": '304',
        //     "user_username_alteracao": 'cm@tradimus',
        //     "dt_alteracao":  '2020-12-11T00:00'
        // }]
        // this.showHistorico = true
      let obj = { query:[{modulo: 'Faturamento', acao: 'gethistoricoguias', payload}] }
       this.$store.dispatch("request/doRequest",obj).then(resp => { 
          if(resp.sucesso) {
            this.historicoEdicoes = resp.dados
            this.showHistorico = true
          }
        })
    },
    filterList(filter) {
      let list = Array.from(this.guiasList)
      let newList = []
      if (filter && list.length) {
        newList = list.reduce((arr, item) => {
          let regex = filter.search ? new RegExp(filter.search, "gi") : null
          let matchSearch = regex ? (
          (item.nome_beneficiario && item.nome_beneficiario.match(regex) != null) ||
          (item.senha && item.senha.match(regex) != null) ||
          (item.numero_guia_prestador && item.numero_guia_prestador.match(regex) != null) ||
          (item.carteira_beneficiario && item.carteira_beneficiario.match(regex) != null)
          ) : true
          if(matchSearch) { arr.push(item) }
          return arr
        }, [])
      }
      this.guiasFilter = newList
    },
    updateGuia(id) {
      this.getGuia = {
        grupo_economico: this.grupoEconomico,
        guia_id: id
      }
    },
    updateGuias(formData){
      let payload = {
        grupo_economico: this.grupoEconomico,
        lote_id: this.$route.params.id,
        ...formData
      }
      let obj = {query:[ {acao: 'updateguias', modulo: 'Faturamento', payload: payload}], noLoader: true, returnError: true}
      this.$store.dispatch("request/doRequest",obj).then(resp => {
         if(resp.response){
                let error = resp
                let paramModal = {}
                      paramModal.message = error.response &&  error.response.data ? (error.response.data.errors ? Object.values(error.response.data.errors).join('<br>') :
                              (error.response.data.message)) : 'Contate o administrador do sistema'
                      paramModal.title = 'Ocorreu erro'
                      paramModal.type = 'error'
                      paramModal.callback = null
                      paramModal.btConfirm = {
                          name: 'Ok',
                          show: true
                      }
                      paramModal.btCancel = {
                          name: 'Cancelar',
                          show: false
                      }
                      
                      this.$store.commit('confirmMessage/showConfirmMessage', paramModal, {root: true})
                      error.sucesso = false
                      return error
            }
        this.updateGuiasResult = resp
      })
    },
    selectGuias(item) {
      this.guiasSelectList = item
    },
    deleteGuia() {
      let paramModal = {
        type: "error",
        btConfirm: { name: "Fechar", show: true },
        btCancel: { name: 'Cancelar', show: false },
        textForm: { show: false }
      }
      if(this.guiasSelectList.length < 1) {
        paramModal.title = "Selecione ao menos uma guia para exclusão"
        paramModal.message = "Você pode excluir uma guia <br/> a um ou vários guias."
      } else {
        paramModal.title = "Excluir guia?"
        paramModal.message = "Ao excluir, este guia não estará mais disponível. <br/> Essa alteração não poderá ser desfeita."
        paramModal.callback = () => {
          let ids = this.guiasSelectList.map(el => Number(el.id))
          let payload = {
            grupo_economico: this.grupoEconomico,
            guia_ids: ids
          }
          this.deleteGuias(payload)
        }
        paramModal.btConfirm.name = 'Excluir'
        paramModal.btConfirm.color = 'error'
        paramModal.btCancel.show = true
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    deleteGuias(payload) {
      let obj = {query:[ {acao: 'deleteguias', modulo: 'Faturamento', payload}]}
        this.$store.dispatch("request/doRequest",obj, {root: true}).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return false
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getGuias(this.payload)
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    async getError(opts) {
      let _this = this
      let obj = {
        query: [{Modulo: "Faturamento", Acao: "geterroslote", Payload: {
          grupo_economico: opts.grupo_economico,
          lote_id: opts.id,
        }}]}
        let hasErro = await this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return false;
        }
        let json = JSON.parse(response.lote_erros)
        this.showError = true
        if (response.lote_erros != null) {
          _this.itemError = json.Erros? json.Erros : json.Erro ? json.Erro : null
          _this.itemCritica = json.criticas? json.criticas : null
          _this.errorType = _this.itemError != null? 1 : 2
        } else {
          _this.itemError = null
          _this.itemCritica = null
          _this.errorType = null
        }
        return true
      })
      return hasErro
    },
    desalocaLote(opts) {
      let payload = {
        grupo_economico: opts.grupo_economico,
        lote_id: opts.id,
        prestador_id: this.loteDataInfo.prestador_id
      }
      let paramModal = {
        type: "info",
        title: "Deseja liberar as edições de guias?",
        message: "As edições serão mantidas e outro usuário poderá editar este lote. <br/> Caso queira gerar novo xml  do lote corrigido para transmissão clique em Concluir Edição",
        callback: () => {
          let obj = {query:[{modulo: 'Faturamento', acao: 'desalocalote', payload}]}
          this.$store.dispatch("request/doRequest",obj).then(resp => {
            if (resp.sucesso)
            this.$router.push('/faturamento/cronogramas/dadosdocronograma/'+this.loteDataInfo.cronograma_id)
            this.getLotesAlocados({grupo_economico: this.grupoEconomico})
          })
        },
        btConfirm: { name: "Ok", show: true, },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    edicaoLote(acao, opts) {
      let payload = {}
      if (acao == 'finalizaedicaoguia') {
        payload = { ...opts, prestador_id: this.loteDataInfo.prestador_id}
      } else {
        payload = {
          grupo_economico: opts.grupo_economico,
          lote_id: opts.lote_id,
          prestador_id: this.loteDataInfo.prestador_id
        }
      }
      let obj = {query:[{modulo: 'Faturamento', acao, payload}]}
      this.$store.dispatch("request/doRequest",obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return false
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.$router.push('/faturamento/cronogramas/dadosdocronograma/'+this.loteDataInfo.cronograma_id)
            this.getLotesAlocados({grupo_economico: this.grupoEconomico})
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
      })
    },
  },
};
</script>

<style>
</style>